import React, { Component } from 'react';
import propsTypes from 'prop-types';
import { connect } from 'react-redux';
import { Panel,Label } from 'react-bootstrap';

import { registerUser, loginUser, logoutUser } from '../actions/userActions';
import { getUserValidity } from '../actions/validityActions';


class UserForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLogin: true,
            username: '',
            email: '',
            password: ''
        }
	this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onCancel = this.onCancel.bind(this)
    }

    componentDidMount() {
        if (this.props.history.location.pathname.includes('/user_login')) {
            this.setState({isLogin: true})
        } else {
            this.setState({isLogin: false})
        }
    }

    componentWillReceiveProps(nextProps) {
        if (Object.keys(nextProps.userinfo).length !==0 && 'token' in nextProps.userinfo && this.props.history.location.pathname.includes('/user_login')) {
            if (nextProps.userinfo.token !== '') {
                this.props.getUserValidity(nextProps.userinfo.token);
                this.props.history.push('/')
            }
        } else if (Object.keys(nextProps.userinfo).length !==0 && 'token' in nextProps.userinfo && this.props.history.location.pathname.includes('/user_register')) {
            this.props.logoutUser();
            alert("您已成功注册，请登录。");
            this.props.history.push('/user_login')
        } 
    }

    onChange(e) {
        this.setState({[e.target.name]: e.target.value})
    }

    onSubmit(e) {
        e.preventDefault();
        const userData = {
            username: this.state.username,
            email: this.state.email,
            password: this.state.password
        }
        if ((this.props.history.location.pathname.includes('/user_login'))) {
            this.props.loginUser(userData);
        } else {
            this.props.registerUser(userData);
            /*alert("您已成功注册，请登录。");*/
            /*this.props.history.push('/user_login')*/
        }
        
    }

    onCancel() {
        this.props.history.push('/')
    }

    render() {
        return (
            <Panel>
                <Panel.Heading>
                    <h3>
                        请{(this.props.history.location.pathname.includes('/user_login')) ? ('登录'):('注册')}
                    </h3>
                </Panel.Heading>
                <Panel.Body>
                    <form onSubmit={this.onSubmit} className="form-element">
                        <label htmlFor="username">帐号</label>
                        <input 
                            type="text" 
                            id="username" 
                            name="username" 
                            onChange={this.onChange} 
                        /><small>{(this.props.history.location.pathname.includes('/user_login'))?'':'仅支持英文字符，建议使用姓名全拼'}</small>   
                        <br />
                        {
                            (this.props.history.location.pathname.includes('/user_login'))?
                            ''
                            :
                            <span>
                                <label htmlFor="email">邮箱</label>
                                <input type="text" id="email" name="email" onChange={this.onChange}/>
                                <small>请输入有效的邮箱地址，用于接收系统消息或找回密码</small>
                                <br/>
                            </span>
                        }
                        <label htmlFor="password">密码</label>
                        <input 
                            type="password" 
                            id="password" name="password"  
                            onChange={this.onChange} 
                        /><small>{(this.props.history.location.pathname.includes('/user_login'))?'':'英文字符或数字组合，至少8位'}</small>
                        <br/>
                        <div>
                            <span>{ ((Object.keys(this.props.userinfo)!==0)&&(!('token' in this.props.userinfo))&&('username' in this.props.userinfo))?(<Label bsStyle="warning">帐号:{this.props.userinfo.username[0]}<br/></Label>):'' }</span>
                            <span>{ ((Object.keys(this.props.userinfo)!==0)&&(!('token' in this.props.userinfo))&&('email' in this.props.userinfo))?(<Label bsStyle="warning">邮箱:{this.props.userinfo.email[0]}<br/></Label>):'' }</span>
                            <span>{ ((Object.keys(this.props.userinfo)!==0)&&(!('token' in this.props.userinfo))&&('password' in this.props.userinfo))?(<Label bsStyle="warning">密码:{this.props.userinfo.password[0]}<br/></Label>):'' }</span>
                            <span>{ ((Object.keys(this.props.userinfo)!==0)&&(!('token' in this.props.userinfo))&&('non_field_errors' in this.props.userinfo))?(<Label bsStyle="warning">错误:{this.props.userinfo.non_field_errors[0]}<br/></Label>):'' }</span>
                        </div>
                        <hr />
                        <button type="submit">{(this.props.history.location.pathname.includes('/user_login'))?'登录':'注册'}</button>
                        <button type="button" onClick={()=>{this.onCancel()}}>取消</button>
                    </form>
                </Panel.Body>
                <Panel.Footer />
            </Panel>
        )
    }
}

UserForm.propsTypes = {
    loginUser: propsTypes.func.isRequired,
    registerUser: propsTypes.func.isRequired,
    logoutUser: propsTypes.func.isRequired,
    getUserValidity: propsTypes.func.isRequired,
    userinfo: propsTypes.object
}

const mapStateToProps = state => ({
    userinfo: state.users.item
})

export default connect(mapStateToProps,{ loginUser, registerUser, logoutUser, getUserValidity })(UserForm);


// WEBPACK FOOTER //
// ./src/components/UserForm.js